/**
 * Time and Day targeting
 * @module
 */

module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/current_timestamp'));
  PluginManager.registerVisitorProfileProvider(require('./providers/offset'));

  PluginManager.registerAudienceMatcher('time_and_day', require('./matcher'));
};
